/* eslint-disable */
export enum FeatureFlagsEnum {
    StudioSamplesCreditIncrease = 'S_StudioCreditIncrease',
    DistributionNewPricing = 'D_NewPricing',
    ChromaticToPlugins = 'B_ChromaticToPlugins',
}
